module.exports = __webpack_public_path__ + "media/lyuk_k.3b8663cd.mp3";